import jsPDF from 'jspdf';
import type { Prescription, Encounter, EncounterWithDetails } from '../types';

export const generatePrescriptionPDF = (
  prescription: Prescription, 
  encounter: Encounter | EncounterWithDetails
) => {
  const doc = new jsPDF();
  
  doc.setFontSize(18);
  doc.text('MEDSYSTEM CLINIC', 20, 25);
  
  doc.setFontSize(12);
  doc.text('123 Medical Street, Healthcare City', 20, 35);
  doc.text('Phone: +1-555-0123 | Email: info@medsystem.com', 20, 42);
  
  // Draw line under header
  doc.line(20, 50, 190, 50);
  
  let yPos = 65;
  doc.setFontSize(14);
  doc.text('PRESCRIPTION', 20, yPos);
  
  yPos += 15;
  doc.setFontSize(12);
  doc.text(`Doctor: ${prescription.signedBy || 'Dr. Unknown'}`, 20, yPos);
  yPos += 8;
  doc.text(`Date: ${new Date(encounter.dateTime).toLocaleDateString()}`, 20, yPos);
  yPos += 8;
  doc.text(`Prescription ID: ${prescription.id}`, 20, yPos);
  
  // Patient info
  yPos += 20;
  doc.text('Patient Information:', 20, yPos);
  yPos += 10;
  
  if ('patient' in encounter && encounter.patient) {
    doc.text(`Name: ${encounter.patient.name}`, 25, yPos);
    yPos += 8;
    if (encounter.patient.email) {
      doc.text(`Email: ${encounter.patient.email}`, 25, yPos);
      yPos += 8;
    }
    if (encounter.patient.phone) {
      doc.text(`Phone: ${encounter.patient.phone}`, 25, yPos);
      yPos += 8;
    }
  } else {
    doc.text(`Patient ID: ${encounter.patientId}`, 25, yPos);
    yPos += 8;
  }
  
  yPos += 15;
  doc.setFontSize(14);
  doc.text('Medications:', 20, yPos);
  
  yPos += 15;
  doc.setFontSize(12);
  
  doc.text('Medicine', 20, yPos);
  doc.text('Dose', 80, yPos);
  doc.text('Frequency', 120, yPos);
  doc.text('Duration', 160, yPos);
  
  // Draw line under header
  doc.line(20, yPos + 3, 190, yPos + 3);
  yPos += 12;
  
  prescription.items.forEach((item, index) => {
    doc.text(`${index + 1}. ${item.nameOrMedicineId}`, 20, yPos);
    doc.text(item.dose, 80, yPos);
    doc.text(item.frequency, 120, yPos);
    doc.text(item.duration, 160, yPos);
    
    if (item.instructions) {
      yPos += 8;
      doc.setFontSize(10);
      doc.text(`   Instructions: ${item.instructions}`, 25, yPos);
      doc.setFontSize(12);
    }
    
    yPos += 12;
  });
  
  yPos += 10;
  doc.text('General Advice:', 20, yPos);
  yPos += 10;
  doc.text('• Take medications as prescribed', 25, yPos);
  yPos += 8;
  doc.text('• Complete the full course of antibiotics if prescribed', 25, yPos);
  yPos += 8;
  doc.text('• Follow up if symptoms persist or worsen', 25, yPos);
  
  yPos += 30;
  doc.text('Doctor Signature: ________________________', 20, yPos);
  yPos += 15;
  doc.text(`Signed by: ${prescription.signedBy || 'Dr. Unknown'}`, 20, yPos);
  yPos += 8;
  doc.text(`Date: ${new Date().toLocaleDateString()}`, 20, yPos);
  
  doc.setFontSize(10);
  doc.text('This is a computer-generated prescription.', 20, 280);
  
  return doc;
};

export const printPrescription = (prescription: Prescription, encounter: Encounter | EncounterWithDetails) => {
  const doc = generatePrescriptionPDF(prescription, encounter);
  doc.autoPrint();
  window.open(doc.output('bloburl'), '_blank');
};

export const downloadPrescription = (prescription: Prescription, encounter: Encounter | EncounterWithDetails) => {
  const doc = generatePrescriptionPDF(prescription, encounter);
  const patientName = ('patient' in encounter && encounter.patient) 
    ? encounter.patient.name.replace(/\s+/g, '_') 
    : `Patient_${encounter.patientId}`;
  const dateStr = new Date(encounter.dateTime).toISOString().split('T')[0].replace(/-/g, '');
  doc.save(`Rx_${patientName}_${dateStr}_${prescription.id}.pdf`);
};
